import { Logger } from '../devtools/logger';

export const createGroupManager = ({
  logger,
}: {
  logger?: Logger;
} = {}) => {
  const groups = new Map<string, Map<string, number>>();

  return {
    has: (group: string) => groups.has(group),

    get: (group: string): ReadonlySet<string> | undefined => {
      const members = groups.get(group);
      return members ? new Set(members.keys()) : undefined;
    },

    add: (group: string, instanceKey: string) => {
      let members = groups.get(group);

      if (!members) {
        members = new Map();
        groups.set(group, members);
      }

      members.set(instanceKey, (members.get(instanceKey) ?? 0) + 1);

      logger?.debug('added to group', { group, instanceKey });
    },

    remove: (group: string, instanceKey: string) => {
      const members = groups.get(group);

      if (!members) {
        return;
      }

      const count = members.get(instanceKey);

      if (count == null) {
        return;
      }

      if (count <= 1) {
        members.delete(instanceKey);

        if (members.size === 0) {
          groups.delete(group);
        }
      } else {
        members.set(instanceKey, count - 1);
      }

      logger?.debug('removed from group', { group, instanceKey });
    },

    getAllMembers: (): Record<string, string[]> => {
      const result: Record<string, string[]> = {};

      for (const [group, members] of groups) {
        result[group] = [...members.keys()];
      }

      return result;
    },
  };
};

export type GroupManager = ReturnType<typeof createGroupManager>;
